<template>
  <div class="LS01_Card" :style="bgColor">
    <CRow>
      <CCol col="4">
        <img
          class="LS01_icon"
          style="width: 100%; height: 100%"
          :src="imgUrl"
        />
      </CCol>
      <CCol col="8">
        <div class="LS01_Cardpicture">
          <p class="LS01_Font LS01_VOCAB_Color" style="margin: 0">{{$helpers.translate(text, lang)}}</p>
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Buttons",
  props: {
      imgUrl: String,
      text: Array,
      size: String,
      bgColor: String,
      alignStyle: String,
  },
  data() {
    return {
      lang: this.$store.state.language.language,
      // used for declare local variable to use in this class
      // Syntax : Name of variable : Default value
      // Example => courses: []
    };
  },
  methods: {
    // used for define functions in each case
    // Syntax : Name of method(){ Actions }
    // Example => onLogin(){ this.$store.dispatch('auth/onLogin') }
  },
  computed: {
    // used for detect data, in this project usually detect the response data from API
    // that collect in the getters of store (vuex)
    // bringing mapGetters to detect in getters of store (vuex)
    // syntax : ...mapGetters({ Name created variable for local data : Name of getters in store })
    // Example => ...mapGetters({ courses : 'courses/allCourses' })
  },
  watch: {
    // used to manage data after detect data
    // Syntax : Existing name of local variable : function(value){ Action }
    // Example => course : function(value){ this.data = value }
    // Value in parameter is the value of detected data changing
  },
  created() {
  
  },
  mounted() {
    // used for manage event when data has changed
  },
  beforeDestroy() {
    // used for update value before close this page
    // สมมติว่าจับเวลาใช้ในหน้านี้กี่นาที ให้มาเก็บในนี้
  },
};
</script>

<style scoped lang="scss">
.btn-custom {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
  padding: 15px;
  transition: 0.3s;
  border-radius: 15px; /* 5px rounded corners */
}

$light-background: #f2ece4;
$light-text: #036;
$dark-background: #6b717f;
$dark-text: #d2e1dd;

@mixin theme-colors($light-theme: true) {
  @if $light-theme {
    background-color: $light-background;
    color: $light-text;
  } @else {
    background-color: $dark-background;
    color: $dark-text;
  }
}

.banner {
  @include theme-colors($light-theme: true);
  body.dark & {
    @include theme-colors($light-theme: false);
  }
}
</style>